import { NavigateFunction } from 'react-router-dom';

import { Button, Tag } from '../../designComponents';
import theme from '../../theme';
import { humanReadableDateWithTime } from '../../utils';
// import { fake_avatar_url } from '../../utils';
type DataType = {
  _id: string;
  permissions: string;
  fullName: string;
  user: { emailAddress: string };
  userAddress: string;
  createdAt: string;
  updatedAt: string;
};
export const getTableData = (navigate: NavigateFunction, data: DataType[]) => {
  return {
    headings: [
      { key: 'date', label: 'Date' },
      { key: 'userName', label: 'User Name' },
      { key: 'userType', label: 'User Type' },
      { key: 'email', label: 'Email Address' },
      { key: 'userAddress', label: 'User Address' },
      { key: 'actions', label: 'Action' },
    ],
    body: data.map((user) => ({
      id: `${user._id}`,
      date: humanReadableDateWithTime(user.createdAt),
      userName: user.fullName,
      email: user.user.emailAddress,
      userAddress: user.userAddress,
      actions: (
        <Button
          variant="secondary"
          onClick={() => navigate(`${user._id}`)}
          style={{
            backgroundColor: theme.colors.blueLight,
            border: `1px solid ${theme.colors.blueLight}`,
          }}
        >
          View Details
        </Button>
      ),
      userType: (
        <Tag type={user.permissions === 'FIREMAN' ? 'danger' : 'caution'}>
          {user.permissions}
        </Tag>
      ),
    })),
  };
};
